export const iconFontAwesomeGamingScroll = (
	<i className="fa-solid fa-scroll"></i>
);
